import { useEffect } from 'react'

const useFreezeModal = () =>
  useEffect(() => {
    document.body.style.height = 'auto'
    document.querySelector('html')?.setAttribute('style', 'overflow: hidden')
    document.querySelector('.lgt-modal__overlay')?.setAttribute('style', 'overflow-y: auto')

    return () => {
      document.body.style.height = 'unset'
      document.querySelector('html')?.removeAttribute('style')
      document.querySelector('.lgt-modal__overlay')?.removeAttribute('style')
    }
  }, [])

export default useFreezeModal
